/** Horizontal gap between chips — same as the Pricer toolbar commodity filters. */
export const SHORTCUT_BUTTON_GAP = 6;

/** Vertical gap when chips wrap inside one group. */
export const SHORTCUT_ROW_GAP = SHORTCUT_BUTTON_GAP;

/**
 * Space around the ranking rule and between groups.
 * Larger than the chip wrap gap so sections read as sections, not extra wrap rows.
 */
export const SHORTCUT_SECTION_GAP = 12;

/** Space from a group label down to its chips — tight so the label belongs to that row. */
export const SHORTCUT_LABEL_GAP = 4;

export const SHORTCUT_BTN_CLASS = "add-option-shortcuts__btn";

export const EMPTY_SHORTCUTS = { suggested: [], items: [], groups: [] };

export const SHORTCUT_GAP_STYLE = {
  "--shortcut-button-gap": `${SHORTCUT_BUTTON_GAP}px`,
  "--shortcut-row-gap": `${SHORTCUT_ROW_GAP}px`,
  "--shortcut-section-gap": `${SHORTCUT_SECTION_GAP}px`,
  "--shortcut-label-gap": `${SHORTCUT_LABEL_GAP}px`,
};

function mapShortcut(item) {
  return {
    id: item.id,
    name: item.name,
    label: item.name,
    value: item.id,
  };
}

function mapShortcutList(list) {
  return Array.isArray(list) ? list.map(mapShortcut) : [];
}

/**
 * GET /add-options/shortcuts `data` is `{ suggested, items, groups }`.
 * Row 1 is `suggested` as sent — no client cap, no padding from `items`.
 */
export function parseShortcutsPayload(data) {
  if (data && !Array.isArray(data) && Array.isArray(data.items)) {
    return {
      suggested: mapShortcutList(data.suggested),
      items: mapShortcutList(data.items),
      groups: (Array.isArray(data.groups) ? data.groups : []).map((group) => ({
        name: group.name,
        items: mapShortcutList(group.items),
      })),
    };
  }
  if (Array.isArray(data)) {
    const items = mapShortcutList(data);
    return { suggested: [], items, groups: [] };
  }
  return EMPTY_SHORTCUTS;
}

export function shortcutItemsFromPayload(data) {
  return parseShortcutsPayload(data).items;
}

/**
 * Groups in backend order, minus any id already in `suggested`.
 * Empty groups are dropped. Does not regroup or parse names.
 */
export function groupsBelowRow1(groups, suggested) {
  const skip = new Set((suggested ?? []).map((item) => item.id));
  return (Array.isArray(groups) ? groups : [])
    .map((group) => ({
      name: group.name,
      items: (group.items ?? []).filter((item) => !skip.has(item.id)),
    }))
    .filter((group) => group.items.length > 0);
}

/** Divider + group headers when anything remains after skipping suggested ids. */
export function shouldShowShortcutGroups(visibleGroups) {
  return visibleGroups.length > 0;
}
